import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")

  return (_openBlock(), _createBlock(_component_BuilderInputs, {
    opts: $data.schema,
    propstore: $props.store,
    onUpdate: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update')))
  }, null, 8 /* PROPS */, ["opts", "propstore"]))
}